'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { usePostHog } from '../Components/PostHogProvider'

export const usePostHogPageView = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { posthog, isLoaded } = usePostHog()

  // Convert searchParams to string for stable dependency
  const searchParamsString = searchParams.toString()

  useEffect(() => {
    if (isLoaded && posthog) {
      // Preserve useful route context without storing student-entered query values.
      posthog.capture('$pageview', {
        $current_url: pathname,
        path: pathname,
        has_search_params: Boolean(searchParamsString),
      })
    }
  }, [pathname, searchParamsString, posthog, isLoaded])
}
